import { render, staticRenderFns } from "./ReturnSend.vue?vue&type=template&id=bec01a48&scoped=true&"
import script from "./ReturnSend.vue?vue&type=script&lang=js&"
export * from "./ReturnSend.vue?vue&type=script&lang=js&"
import style0 from "./ReturnSend.vue?vue&type=style&index=0&id=bec01a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec01a48",
  null
  
)

export default component.exports